import { useEffect } from 'react';
import { useSearchContext } from '@/context';
import { trackGAEvent } from '@/services';

export const useAnalytics = () => {
  const { searchResults, facet, searchQuery, loading } = useSearchContext();

  useEffect(() => {
    if (loading || !searchResults?.results) {
      return;
    }

    const results = searchResults?.results ?? [];
    const resultCount = searchResults?.resultCount ?? 0;
    const query = searchQuery ?? '';
    const searchFacetString = facet;

    if (resultCount > 0) {
      trackGAEvent({
        event: 'view_global_search_results',
        search_term: query,
        search_facet: searchFacetString,
        search_result_count: resultCount,
        search_count: 1,
      });
    } else {
      trackGAEvent({
        event: 'search_zero_results',
        search_term: query,
        search_facet: searchFacetString,
        search_zero_result_count: 1,
      });
    }

    const resultIds = results.map((result) => result.id);
    const uniqueResultIds = new Set(resultIds);
    if (resultIds.length !== uniqueResultIds.size) {
      trackGAEvent({
        event: 'search_duplicate_results',
        search_term: query,
        search_facet: searchFacetString,
        number_of_duplicates: resultIds.length - uniqueResultIds.size,
        search_duplicate_count: 1,
      });
    }
  }, [searchQuery, searchResults, facet, loading]);
};
